import { CartAddEvent } from '@theme/events';

/**
 * Confezione regalo nel carrello (snippets/cart-gift-wrap.liquid).
 * "Aggiungi" mette il prodotto nel carrello e fa ridisegnare cassetto/pagina (CartAddEvent, come Horizon);
 * il messaggio del biglietto viene salvato come proprietà "Biglietto" della riga.
 */
class CartGiftWrap extends HTMLElement {
  /** @type {number | undefined} */
  #saveTimer;

  connectedCallback() {
    this.addEventListener('click', this.#onClick);
    this.addEventListener('input', this.#onInput);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
    this.removeEventListener('input', this.#onInput);
  }

  #onClick = async (/** @type {MouseEvent} */ event) => {
    const button = event.target instanceof Element ? event.target.closest('.cart-gift-wrap__add') : null;
    if (!(button instanceof HTMLButtonElement)) return;

    button.disabled = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(this.dataset.variantId), quantity: 1 }] }),
      });
      if (!response.ok) throw new Error(`cart/add ${response.status}`);

      const cart = await (await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`)).json();
      document.dispatchEvent(
        new CartAddEvent({}, 'cart-gift-wrap', {
          source: 'cart-gift-wrap',
          itemCount: cart.item_count,
          variantId: this.dataset.variantId,
        })
      );
    } catch (error) {
      console.error(error);
      button.disabled = false;
    }
  };

  #onInput = (/** @type {Event} */ event) => {
    if (!(event.target instanceof HTMLTextAreaElement)) return;

    const message = event.target.value;
    const status = this.querySelector('.cart-gift-wrap__status');
    if (status) status.textContent = '';

    window.clearTimeout(this.#saveTimer);
    this.#saveTimer = window.setTimeout(() => this.#saveMessage(message, status), 700);
  };

  /**
   * @param {string} message
   * @param {Element | null} status
   */
  async #saveMessage(message, status) {
    if (!this.dataset.lineKey) return;

    try {
      const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: this.dataset.lineKey,
          quantity: 1,
          properties: message.trim() ? { Biglietto: message.trim() } : {},
        }),
      });
      if (!response.ok) throw new Error(`cart/change ${response.status}`);

      // Le proprietà cambiano la chiave della riga: la aggiorno per i salvataggi successivi
      const cart = await response.json();
      const variantId = Number(this.dataset.variantId);
      const line = cart.items.find((/** @type {{ variant_id: number }} */ item) => item.variant_id === variantId);
      if (line) this.dataset.lineKey = line.key;
      if (status) status.textContent = 'Messaggio salvato';
    } catch (error) {
      console.error(error);
      if (status) status.textContent = 'Non è stato possibile salvare il messaggio, riprova.';
    }
  }
}

if (!customElements.get('cart-gift-wrap')) {
  customElements.define('cart-gift-wrap', CartGiftWrap);
}
